'use strict'

import React, { useEffect, useRef } from 'react'

let lottieAssetsPromise = null

/**
 * Лениво загружаем плеер lottie-web (light-сборка: только SVG, без expressions)
 * и json анимации отдельным чанком. Промис кешируется, чтобы чанк грузился один раз.
 * webpackPrefetch добавляет <link rel="prefetch">: браузер скачивает чанк в простое,
 * но не выполняет его, пока лоадер реально не понадобится
 */
const loadLottieAssets = () => {
  if (!lottieAssetsPromise) {
    lottieAssetsPromise = Promise.all([
      import(/* webpackChunkName: "lottie-loader", webpackPrefetch: true */ 'lottie-web/build/player/lottie_light'),
      import(/* webpackChunkName: "lottie-loader", webpackPrefetch: true */ './img/loader.json'),
    ]).then(([lottieModule, animationModule]) => ({
      lottie: lottieModule.default,
      animationData: animationModule.default,
    }))
  }

  return lottieAssetsPromise
}

function LottieLoader () {
  const containerRef = useRef(null)

  useEffect(() => {
    let animation = null
    let isUnmounted = false

    loadLottieAssets()
      .then(({ lottie, animationData }) => {
        if (isUnmounted || !containerRef.current) return

        animation = lottie.loadAnimation({
          container: containerRef.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          // lottie-web мутирует переданные данные, поэтому каждому экземпляру — своя копия
          animationData: JSON.parse(JSON.stringify(animationData)),
        })
      })
      .catch(() => {})

    return () => {
      isUnmounted = true
      if (animation) animation.destroy()
    }
  }, [])

  return <div className="lottie-loader" ref={containerRef} style={{ width: 160 }}/>
}

export default LottieLoader